import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {


fetchsizeData(ctx, queryParams){
  var data = JSON.stringify(queryParams);
      
      return new Promise((resolve, reject) => {
        axios
          .post('/products/v1/size/getall',data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
},
addSize(ctx,queryParams){

  return new Promise((resolve, reject) => {
    axios
      .post('/products/v1/size/add',queryParams.formData)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
},
updateSize(ctx,queryParams){

      
  return new Promise((resolve, reject) => {
    axios
      .put('/products/v1/size/update/'+queryParams.data.id,queryParams.formData)
      
      .then(response => resolve(response))
      .catch(error => reject(error))
  })

},
updateSizeOrdering(ctx, queryParams) {
    var data = JSON.stringify(queryParams);
    
    return new Promise((resolve, reject) => {
      axios
        .put('/products/v1/size/updateOrdering',data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
},
deleteSize(ctx,id){
  
    
    return new Promise((resolve, reject) => {
      axios
        .delete('/products/v1/size/delete/'+id)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })

},

fetchadditionalData(ctx, queryParams){
  var data = JSON.stringify(queryParams);
      
      return new Promise((resolve, reject) => {
        axios
          .post('/products/v1/additional/getall',data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
},
addAdditional(ctx,queryParams){

  return new Promise((resolve, reject) => {
    axios
      .post('/products/v1/additional/add',queryParams.formData)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
},
updateAdditional(ctx,queryParams){

      
  return new Promise((resolve, reject) => {
    axios
      .put('/products/v1/additional/update/'+queryParams.data.id,queryParams.formData)
      
      .then(response => resolve(response))
      .catch(error => reject(error))
  })

},
updateAdditionalOrdering(ctx, queryParams) {
    var data = JSON.stringify(queryParams);
    
    return new Promise((resolve, reject) => {
      axios
        .put('/products/v1/additional/updateOrdering',data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
},
deleteAdditional(ctx,id){
  
    
    return new Promise((resolve, reject) => {
      axios
        .delete('/products/v1/additional/delete/'+id)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })

},

      fetchcontentsData(ctx, queryParams){
        var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/products/v1/contents/getall',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
      },
      addContents(ctx,queryParams){

        return new Promise((resolve, reject) => {
          axios
            .post('/products/v1/contents/add',queryParams.formData)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      },
      updateContents(ctx,queryParams){

            
        return new Promise((resolve, reject) => {
          axios
            .put('/products/v1/contents/update/'+queryParams.data.id,queryParams.formData)
            
            .then(response => resolve(response))
            .catch(error => reject(error))
        })

      },
      updateContentsOrdering(ctx, queryParams) {
          var data = JSON.stringify(queryParams);
          
          return new Promise((resolve, reject) => {
            axios
              .put('/products/v1/contents/updateOrdering',data)
              .then(response => resolve(response))
              .catch(error => reject(error))
          })
      },
      deleteContents(ctx,id){
        
          
          return new Promise((resolve, reject) => {
            axios
              .delete('/products/v1/contents/delete/'+id)
              .then(response => resolve(response))
              .catch(error => reject(error))
          })

      },

      fetchCats(ctx, queryParams) {
        var data = JSON.stringify(queryParams);
        return new Promise((resolve, reject) => {
          axios
            .post('/products/v1/category/list', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      },
        fetchCatsSeleted(ctx,queryParams){
          
          var data = JSON.stringify(queryParams);
            
          return new Promise((resolve, reject) => {
            axios
              .post('/products/v1/category/getseletedall',data)
              .then(response => resolve(response))
              .catch(error => reject(error))
          })

        },
        addCategory(ctx, queryParams){
          var data = JSON.stringify(queryParams);

          return new Promise((resolve, reject) => {
            axios
              .post('/products/v1/category/add',data)
              .then(response => resolve(response))
              .catch(error => reject(error))
          })
        },
        updateCategory(ctx, queryParams){
          var data = JSON.stringify(queryParams);

          return new Promise((resolve, reject) => {
            axios
              .post('/products/v1/category/update/'+queryParams.id,data)
              .then(response => resolve(response))
              .catch(error => reject(error))
          })
        },
        updateCategoryOrdering(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .put('/products/v1/category/updateOrdering',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteCategory(ctx,id){

            
            return new Promise((resolve, reject) => {
              axios
                .delete('/products/v1/category/delete/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })

        },
       
        fetchData(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/products/v1/getall',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
      addProduct(ctx, queryParams){
        return new Promise((resolve, reject) => {
          axios
            .post('/products/v1/add', queryParams.formData)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      },
      updateProductsOrdering(ctx, queryParams) {
        var data = JSON.stringify(queryParams);
        
        return new Promise((resolve, reject) => {
          axios
            .put('/products/v1/updateOrdering',data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      },
      updateProduct(ctx, data){
        return new Promise((resolve, reject) => {
          axios
            .post(`/products/v1/update`, data.formData, {
              headers:{
                  'Content-Type': 'multipart/form-data',
                  'dataType':'json'
              }
            })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      },
      deleteProducts(ctx,id){
        
          
        return new Promise((resolve, reject) => {
          axios
            .delete('/products/v1/delete/'+id)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })

    },
    fetchImages(ctx, queryParams) {
        var data = JSON.stringify(queryParams);
        
        return new Promise((resolve, reject) => {
          axios
            .post('/products/v1/image/getall',data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    fetchImageUpdate(ctx, queryParams){

      var data = JSON.stringify(queryParams);
      return new Promise((resolve, reject) => {
        axios
          .put('/products/v1/image/update/'+queryParams.id,data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
        
    },
    updateOrdering(ctx, queryParams) {
        var data = JSON.stringify(queryParams);
        
        return new Promise((resolve, reject) => {
          axios
            .put('/products/v1/image/updateOrdering',data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    
    uploadimages(ctx,queryParams){
      return new Promise((resolve, reject) => {
        axios
          .post('/products/v1/image/add/'+queryParams.id,queryParams.formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

    },
    fetchImageDelete(ctx,id){
      return new Promise((resolve, reject) => {
        axios
          .delete('/products/v1/image/delete/'+id)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

    },
    addSubCategory(ctx,queryParams){
            
            return new Promise((resolve, reject) => {
              axios
                .post('/products/v1/sub/category/add',queryParams.formData)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })

        },
        updateSubCategory(ctx,queryParams){

            
            return new Promise((resolve, reject) => {
              axios
                .put('/products/v1/sub/category/update/'+queryParams.data.id,queryParams.formData,{
                  headers:{
                    'Content-Type': 'multipart/form-data',
                    'dataType':'json'
                  }
                })
                .then(response => resolve(response))
                .catch(error => reject(error))
            })

        },
    updateSubCategoryOrdering(ctx, queryParams) {
      var data = JSON.stringify(queryParams);
      
      return new Promise((resolve, reject) => {
        axios
          .put('/products/v1/sub/category/updateOrdering',data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteSubCategory(ctx,id){
      
        
      return new Promise((resolve, reject) => {
        axios
          .delete('/products/v1/sub/category/delete/'+id)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

  },
  getCatagoriesBySite(ctx, queryParams) {
    var data = JSON.stringify(queryParams);
    
    return new Promise((resolve, reject) => {
      axios
        .post('/products/v1/category/getallbysite',data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  fetchProducts(ctx, queryParams){
    var data = JSON.stringify(queryParams);

    return new Promise((resolve, reject) => {
      axios
        .post('/products/v1/list', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  updateBlogsOrdering(ctx, queryParams) {
    var data = JSON.stringify(queryParams);
    
    return new Promise((resolve, reject) => {
      axios
        .post('/products/v1/updateOrdering', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  },
}